import React, { ReactNode } from 'react';

import './DetailSection.scss';

interface DetailSectionProps {
    id: string;
    children: ReactNode;
    title: string;
}

export default function DetailSection(props: DetailSectionProps) {
    const { id, children, title } = props;

    return (
        <section id={id} className="detail-section">
            <h3 className="detail-section__title">{title}</h3>
            <div className="detail-section__body">{children}</div>
        </section>
    );
}

DetailSection.defaultProps = {
    id: '',
    children: <></>,
    title: '',
};
